import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import makeStyles from '@mui/styles/makeStyles';
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAttributePreference } from '../common/util/preferences';
import StatusCard from '../common/components/StatusCard';
import { devicesActions } from '../store';
import usePersistedState from '../common/util/usePersistedState';
import MainMap from './MainMap';
import NewMainPanel from './NewMainPanel';

const useStyles = makeStyles({
  root: {
    height: '100%',
  },
});

const NewMainPage = () => {
  const classes = useStyles();
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up('md'));
  const mapOnSelect = useAttributePreference('mapOnSelect', true);
  const dispatch = useDispatch();

  const [keyword, setKeyword] = useState('');
  const [filter, setFilter] = usePersistedState('filter', {
    statuses: [],
    groups: [],
  });
  const [filterSort, setFilterSort] = usePersistedState('filterSort', '');
  const [filterMap, setFilterMap] = usePersistedState('filterMap', false);
  const [eventsOpen, setEventsOpen] = useState(false);
  const [showVehicles, setShowVehicles] = useState(false);
  const selectedDeviceId = useSelector((state) => state.devices.selectedId);

  const onEventsClick = useCallback(() => setEventsOpen(true), [setEventsOpen]);

  return (
    <div className={classes.root}>
      {desktop && (
        <>
          <NewMainPanel keyword={keyword} setKeyword={setKeyword} filterSort={filterSort} setFilterSort={setFilterSort} filterMap={filterMap} setFilterMap={setFilterMap} />
          <MainMap
            keyword={keyword}
            filter={filter}
            filterSort={filterSort}
            filterMap={filterMap}
            onEventsClick={onEventsClick}
          />
          {selectedDeviceId && (
          <StatusCard
            keyword={keyword}
            filter={filter}
            filterSort={filterSort}
            filterMap={filterMap}
            deviceId={selectedDeviceId}
            onClose={() => dispatch(devicesActions.select(null))}
            desktopPadding={theme.dimensions.drawerWidthDesktop}
          />
          )}
        </>

      )}
    </div>
  );
};

export default NewMainPage;
